import createHasSubmitFailed from './selectors/hasSubmitFailed';
import plain from './structure/plain';
export default createHasSubmitFailed(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/hasSubmitFailed.js
// module id = VC8k
// module chunks = 1